import React from 'react';
import { connect } from 'react-redux';
import { editUser, postChangeStateUsuario } from '../../api/axios';
import { fetchUsuario, editUsuario, userTypeIds } from '../../actions/usuariosActions';
import { editando, setObject } from '../../actions/generalActios';
import PasswordValidation from "./PasswordValidation";
import UserSidebarItems from "./UserSidebarItems";
import GoBackArrow from '../General/GoBackArrow';
import MiniSpinner from '../General/MiniSpinner';
import Auth from "../../auth";
import { isEmail } from "../../utilities/formatString";
import { toast } from 'react-toastify';

class UserNew extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            didEdit: false,
            password: "",
            passValidation: false,
            confirmPassword: "",
            usuarioError: true,
            showSpinner: false,
            hiddenItems: this.props.usuario.perfil
        }
    };

    componentDidMount() {
        this.props.fetchUsuario({ idUsuario: parseInt(this.props.match.params.id) });
        if (this.props.history.location.pathname != `/Usuarios/Editar/${this.props.match.params.id}`) {
            this.props.setObject({});
        }
        this.props.editUsuario(this.props.usuario);
        this.props.editando(true);
    }

    componentDidUpdate(prevProps) {
        const { idUsuario, perfil } = prevProps?.usuario;
        if (idUsuario !== this.props.usuario.idUsuario || perfil !== this.props.usuario.perfil) {
            this.setState({ hiddenItems: this.props.usuario.perfil });
        }
    }

    changePassword = (e) => {
        const { value } = e.target;
        this.setState({ password: value });
    }

    handlePassValidation = (isSuccess) => {
        this.setState({ passValidation: isSuccess });
    };

    confirmPassword = (e) => {
        const { value } = e.target;
        this.setState({
            usuarioError: value !== this.state.password,
            confirmPassword: value
        });
    }

    myChangeHandler = (event) => {
        this.setState({ didEdit: true })
        let usuario = this.props.usuario;
        usuario[event.target.name] = event.target.value;
        this.props.editUsuario(usuario);
    }

    updateHiddenItems = (hiddenItems) => {
        this.setState({ hiddenItems });
    };

    onSwitchChange = () => {
        let activo = document.querySelector('#switchLectura').checked;
        let valueEstado = activo ? true : false;

        this.setState({ soloLectura: valueEstado, didEdit: true });

        let usuario = this.props.usuario;
        usuario["soloLectura"] = valueEstado;
        this.props.editUsuario(usuario);
    }

    onSwitchStateChange = () => {
        let activo = document.querySelector('#switchEstado').checked;
        let valueEstado = activo ? true : false;

        this.setState({ activo: valueEstado, didEdit: true });

        let usuario = this.props.usuario;
        usuario["activo"] = valueEstado;
        let request = {
            idUsuario: this.props.usuario.idUsuario,
            idSeller: this.props.usuario.idSeller,
            usuario: this.props.usuario.nombreUsuario,
            activar: this.props.usuario.activo,
            pausar: !this.props.usuario.activo
        }

        let res = postChangeStateUsuario(request);

        res.then(res => {
            toast.success("Estado editado exitosamente");
            if (this.props.userType.isResetPassword) {
                this.onLogout()
            } else {
                this.goBack();
            }
        }).catch(err => {
            (err.response.data.errores)
                ? err.response.data.errores.forEach(error => toast.error(error))
                : toast.error("No pudo editarse")
                ;
        }).finally(() => {
            this.setState({ showSpinner: false });
        });
    }

    onSubmit = async (event) => {
        event.preventDefault();
        const { email, nombreUsuario, idUsuario, idSeller, soloLectura } = this.props.usuario;

        if (!isEmail(email)) {
            if (email == "") {
                toast.warn("Ingrese un e-mail de usuario");
                return;
            }
            toast.warn("Mail incorrecto");
            return;
        }

        if (nombreUsuario == "") {
            toast.warn("Ingrese un nombre de usuario");
            return;
        }

        if (!this.state.passValidation) {
            toast.warn("La contraseña no cumple con los requisitos");
            return;
        }

        if (idUsuario === this.props.idUsuario && this.state.usuarioError) {
            toast.warn("Las contraseñas no coinciden");
            return;
        }

        const { password, hiddenItems } = this.state;

        let userUpdated = {
            idUsuario: idUsuario,
            idSeller: idSeller,
            email: email,
            password: password,
            usuario: nombreUsuario,
            soloLectura: soloLectura,
            identificadores: hiddenItems
        };

        this.setState({ showSpinner: true });
        let response = editUser(userUpdated);

        response.then(res => {
            toast.success("Usuario editado exitosamente");
            this.props.userType.isResetPassword
                ? this.onLogout()
                : this.goBack();
        }).catch(err => {
            (err.response.data.errores)
                ? err.response.data.errores.forEach(error => toast.error(error))
                : toast.error("No pudo editarse");
        }).finally(() => {
            this.setState({ showSpinner: false });
        });
    }

    onLogout = () => {
        Auth.logout();
        this.props.history.push("/login");
    }

    goBack = () => {
        window.history.go(-1);
    }


    render() {
        const { userType, usuario } = this.props;
        const canEditUserItems =
            usuario.tipoUsuario !== userTypeIds.isAdminMod &&
            usuario.tipoUsuario !== userTypeIds.isSellerAdmin;
        const rowSize = (userType.isAdminMod || userType.isSellerAdmin) &&
            canEditUserItems ? "col-12 col-sm-6" : "col-12";
        const colSize = (userType.isAdminMod || userType.isSellerAdmin) &&
            canEditUserItems ? "col-12" : "col-12 col-sm-6";

        return (
            <form className="container card form-horizontal form-material" onSubmit={this.onSubmit}>
                <div className="row card-body p-3">

                    <div className="col-12 mb-3">
                        <GoBackArrow />
                        <h4 className="card-title d-block d-sm-inline">
                            {userType.isResetPassword
                                ? "Renovar Password"
                                : "Editar usuario"
                            }
                        </h4>
                    </div>

                    <div className={rowSize}>
                        <div className="row">

                            <div className={colSize}>
                                <div className="form-group">
                                    <label>Email Usuario</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={usuario.email}
                                        onChange={this.myChangeHandler}
                                        placeholder="usuario@dominio.com"
                                        name="email"
                                    />
                                </div>
                            </div>

                            <div className={colSize}>
                                <div className="form-group">
                                    <label>Usuario</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={usuario.nombreUsuario}
                                        onChange={this.myChangeHandler}
                                        placeholder="nombreUsuario"
                                        name="nombreUsuario"
                                        maxLength="40"
                                    />
                                </div>
                            </div>

                            <div className={colSize}>
                                <div className="form-group">
                                    <label>
                                        {userType.isResetPassword
                                            ? "Nueva contraseña"
                                            : "Contraseña"
                                        }
                                    </label>
                                    <input
                                        type="password"
                                        className="form-control"
                                        value={this.state.password}
                                        onChange={this.changePassword}
                                        maxLength="12"
                                    />
                                </div>
                            </div>

                            <div className={colSize}>
                                <div className="form-group">
                                    <label>
                                        {userType.isResetPassword
                                            ? "Confirmar nueva contraseña"
                                            : "Confirmar contraseña"
                                        }
                                    </label>
                                    <input
                                        type="password"
                                        className={`form-control ${this.state.usuarioError ? "warning-input" : ""}`}
                                        value={this.state.confirmPassword}
                                        onChange={this.confirmPassword}
                                        maxLength="12"
                                    />
                                </div>
                            </div>

                            <div className="col-12 col-sm-6 d-inline">
                                <label htmlFor="passwordValidation">Requisitos contraseña</label>
                                <PasswordValidation
                                    password={this.state.password}
                                    isValidPassword={this.handlePassValidation}
                                />
                            </div>

                            <div className="form-group col-12 col-sm-6">
                                <div className="col-12 col-sm-6">
                                    <label className="control-label">Estado</label>
                                    <div className="custom-control custom-switch">
                                        <input
                                            type="checkbox"
                                            id="switchEstado"
                                            disabled={userType.isSellerAdmin}
                                            className="custom-control-input big-checkbox"
                                            onChange={this.onSwitchStateChange}
                                            checked={usuario.activo}
                                        />

                                        <label
                                            className="custom-control-label mx-1"
                                            htmlFor="switchEstado"
                                        >
                                            Activo
                                        </label>
                                    </div>
                                </div>

                                {userType.isAdminMod &&
                                    <div className="col-12 col-sm-auto">
                                        <input
                                            type="checkbox"
                                            id="switchLectura"
                                            className="custom-control-input big-checkbox"
                                            onChange={this.onSwitchChange}
                                            checked={usuario.soloLectura}
                                        />
                                        <label className="custom-control-label mx-1" htmlFor="switchLectura">
                                            Solo Lectura
                                        </label>
                                    </div>
                                }
                            </div>

                        </div>
                    </div>

                    {(userType.isAdminMod || userType.isSellerAdmin) && canEditUserItems &&
                        <div className="col-12 col-sm-6">
                            <UserSidebarItems
                                tipoUsuario={usuario.tipoUsuario}
                                previousHiddenItems={this.state.hiddenItems}
                                updateHiddenItems={this.updateHiddenItems}
                            />
                        </div>
                    }

                    <div className="col-12 mt-4">
                        <div className="row justify-content-center align-items-center">

                            <div className="col-12 col-sm-auto" hidden={!this.state.showSpinner}>
                                <MiniSpinner />
                            </div>

                            <div className="col-12 col-sm-auto">
                                <button
                                    type="submit"
                                    disabled={this.state.showSpinner}
                                    className="btn btn-sm background-rojo-megatone waves-light col-auto mx-2"
                                >
                                    Guardar
                                </button>
                            </div>

                            <div className="col-12 col-sm-auto">
                                <button
                                    type="button"
                                    onClick={this.goBack}
                                    className="btn btn-sm btn-light waves-effect waves-light col-auto mx-2"
                                >
                                    Cancelar
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            </form>
        );
    }
}


const mapStateToProps = (state) => ({
    userType: state.general.userType,
    idUsuario: state.general.userId,
    idSeller: state.general.idSeller,
    settedSellerObject: state.general.generalObject,
    settedTiposPublicacion: state.tiposPublicacion.setTiposPublicacion,
    usuario: JSON.stringify(state.usuarios.user) != "{}"
        ? state.usuarios.user
        : state.usuarios.usuario
});

export default connect(mapStateToProps, {
    fetchUsuario,
    editando,
    setObject,
    editUsuario
})(UserNew);